module.exports = __webpack_public_path__ + "static/media/edit.80cda1fc.svg";